import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-jobsearch-search_card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_card_header __sub" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "p-jobsearch-search_card_header_hl" }, "勤務地を選択"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "p-jobsearch-search_card_header_back js-modal-close-trigger",
    type: "button"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "戻る")
  ])
], -1)
const _hoisted_3 = { class: "p-jobsearch-search_card_body __sub js-tab-container" }
const _hoisted_4 = { class: "p-jobsearch-search_card_sub __no-sp" }
const _hoisted_5 = { class: "p-jobsearch-search_tab" }
const _hoisted_6 = ["data-tab"]
const _hoisted_7 = { class: "p-jobsearch-search_card_main __no-tab" }
const _hoisted_8 = {
  class: "p-jobsearch-search_content __sub",
  id: "jobsearch-location-dialog-body"
}
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "p-jobsearch-search_accordion __first" }
const _hoisted_11 = { class: "p-jobsearch-search_accordion_wp js-check-parent_wp" }
const _hoisted_12 = { class: "p-jobsearch-search_check" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-search_check_icon" }, null, -1)
const _hoisted_14 = ["checked", "onChange"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "p-jobsearch-search_accordion_wp js-check-parent_wp" }
const _hoisted_17 = { class: "p-jobsearch-search_check" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-search_check_icon" }, null, -1)
const _hoisted_19 = ["checked", "onChange"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "p-jobsearch-search_accordion_content __third"
}
const _hoisted_22 = { class: "p-jobsearch-search_accordions __3clm" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-search_check_icon" }, null, -1)
const _hoisted_24 = ["checked", "onChange"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_bg js-modal-close-trigger" }, null, -1)

import { onMounted, ref, computed, watch, nextTick } from 'vue';
import { JobSearchSelectedCheckboxListItem } from '@/types';
import { DialogPrefData, Level1MstCityPref, Level2MstCityPref, Level3MstCityPref } from '@/types/mstMyPage';
import { useStore } from 'vuex';
import { domHelperUtils } from '@/utils/domHelper';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';

export default /*#__PURE__*/_defineComponent({
  __name: 'Location',
  props: {
    selectedLocations: null,
    refreshKey: null
  },
  emits: ["update:selectedLocations"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:selectedLocations', value: {
    jobsearchAreaid: string[],
    jobsearchPrefid: number[],
    jobsearchCityid: number[],
    displayLocationList: JobSearchSelectedCheckboxListItem[],
  }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  selectedLocations?: {
    jobsearchAreaid: string[],
    jobsearchPrefid: number[],
    jobsearchCityid: number[],
  },
  refreshKey: number,
}

const storeBase = MYPAGE_CONSTANTS.STORE_MST;

const dialogData = ref<DialogPrefData>();

// Props/Emitsの設定




watch(() => props.selectedLocations, (newValue) => {
  if (newValue && dialogData.value) {
    updateCheckboxesFromIds(newValue);
  }
}, { deep: true });

watch(() => props.refreshKey, () =>{
  setTimeout(()=>{
    emit('update:selectedLocations', selectedLocations.value);
  });
});

// 選択された場所の計算プロパティ
const selectedLocations = computed(() => {
  if (!dialogData.value) return {
    jobsearchAreaid: [],
    jobsearchPrefid: [],
    jobsearchCityid: [],
    displayLocationList: [],
  };
  const result = {
    jobsearchAreaid: [] as string[],
    jobsearchPrefid: [] as number[],
    jobsearchCityid: [] as number[],
    displayLocationList: [] as JobSearchSelectedCheckboxListItem[],
  };

  dialogData.value!.checkbox1.forEach(box1 => {
    // checkbox1がチェックされている場合、そのIDをjobsearchAreaidに追加
    if (box1.isChecked) {
      result.jobsearchAreaid.push(box1.id.toString());
      result.displayLocationList.push({
        id: box1.id.toString(),
        // eslint-disable-next-line no-irregular-whitespace
        text: box1.text + `${box1.id.toString() != MYPAGE_CONSTANTS.MSTAREA_FOREIGN_ID ? '　すべて' : ''}`,
        isChecked: true,
        level: 1,
      });
    } else {
      // checkbox1がチェックされていない場合、チェックされているcheckbox2を処理
      box1.checkbox2.forEach(box2 => {
        if (box2.isChecked) {
          // checkbox2がチェックされている場合、そのIDをjobsearchPrefidに追加
          // 文字列から数値に変換
          const prefId = parseInt(box2.id.toString());
          if (!isNaN(prefId)) {
            result.jobsearchPrefid.push(prefId);
            result.displayLocationList.push({
              id: box2.value,
              text: `${box1.text} ${box2.text}`,
              isChecked: true,
              level: 2,
            });
          }
        } else {
          // checkbox2もチェックされていない場合、チェックされているcheckbox3を処理
          box2.checkbox3.forEach(box3 => {
            if (box3.isChecked) {
              // checkbox3がチェックされている場合、そのIDをjobsearchCityidに追加
              // 文字列から数値に変換（ID形式が "123_456" のような場合は後半部分を取得）
              const cityId = parseInt(box3.value);
              if (!isNaN(cityId)) {
                result.jobsearchCityid.push(cityId);
                result.displayLocationList.push({
                  id: box3.value,
                  text: `${box1.text} ${box2.text} - ${box3.text}`,
                  isChecked: true,
                  level: 3,
                });
              }
            }
          });
        }
      });
    }
  });

  return result;
});

// 条件をクリア
function clearAllSelections() {
  if (!dialogData.value) return;

  // すべてのチェックボックスの選択を解除
  dialogData.value.checkbox1.forEach(box1 => {
    // 第1階層のチェックボックスをクリア
    box1.isChecked = false;

    box1.checkbox2.forEach(box2 => {
      // 第2階層のチェックボックスをクリア
      box2.isChecked = false;

      box2.checkbox3.forEach(box3 => {
        // 第3階層のチェックボックスをクリア
        box3.isChecked = false;
      });
    });
  });

  // 親コンポーネントに空のオブジェクトを送信
  emit('update:selectedLocations', {
    jobsearchAreaid: [],
    jobsearchPrefid: [],
    jobsearchCityid: [],
    displayLocationList: [],
  });
}

// 指定する
function submitSelection() {
  emit('update:selectedLocations', selectedLocations.value);

  // remove opened items style
  const openedItems = document.querySelectorAll('#jobsearch-location-dialog-body .-is-opened');
  setTimeout(() => {
    openedItems.forEach(item => {
      (item as HTMLElement).style = '';
    });
  });
}

// IDリストからチェックボックスの状態を更新
function updateCheckboxesFromIds(selectedData: {
  jobsearchAreaid: string[],
  jobsearchPrefid: number[],
  jobsearchCityid: number[]
}) {
  if (!dialogData.value) return;

  // まずすべてのチェックボックスをクリア
  dialogData.value.checkbox1.forEach(box1 => {
    box1.isChecked = false;
    box1.isOpened = false;
    box1.checkbox2.forEach(box2 => {
      box2.isChecked = false;
      box2.isOpened = false;
      box2.checkbox3.forEach(box3 => {
        box3.isChecked = false;
      });
    });
  });

  // checkbox1（第1階層）のチェックを設定
  dialogData.value.checkbox1.forEach(box1 => {
    if (selectedData.jobsearchAreaid.includes(box1.id.toString())) {
      box1.isChecked = true;
      box1.isOpened = false;
      // 第1階層がチェックされている場合、すべての子要素もチェック
      box1.checkbox2.forEach(box2 => {
        box2.isChecked = true;
        box2.checkbox3.forEach(box3 => {
          box3.isChecked = true;
        });
      });
    }
  });

  // checkbox2（第2階層）のチェックを設定（checkbox1がチェックされていない場合のみ）
  dialogData.value.checkbox1.forEach(box1 => {
    if (!box1.isChecked) {
      box1.checkbox2.forEach(box2 => {
        // 文字列から数値に変換して比較
        const prefId = parseInt(box2.id.toString());
        if (!isNaN(prefId) && selectedData.jobsearchPrefid.includes(prefId)) {
          box2.isChecked = true;
          box2.isOpened = false;
          box1.isOpened = true;
          // 第2階層がチェックされている場合、すべての子要素もチェック
          box2.checkbox3.forEach(box3 => {
            box3.isChecked = true;
          });
        }
      });
    }
  });

  // checkbox3（第3階層）のチェックを設定（checkbox1とcheckbox2がチェックされていない場合のみ）
  dialogData.value.checkbox1.forEach(box1 => {
    if (!box1.isChecked) {
      let isBox1Open = false;
      box1.checkbox2.forEach(box2 => {
        let isBox2Open = false;
        if (!box2.isChecked) {
          box2.checkbox3.forEach(box3 => {
            // ID形式が "123_456" のような場合は後半部分を取得して数値に変換
            const cityIdStr = box3.id.toString().split('_')[1] || box3.id.toString();
            const cityId = parseInt(cityIdStr);

            if (!isNaN(cityId) && selectedData.jobsearchCityid.includes(cityId)) {
              box3.isChecked = true;
              isBox1Open = true;
              isBox2Open = true;
            }
          });

          // box2の状態を更新（すべての子要素がチェックされていれば親もチェック）
          const allBox3Checked = box2.checkbox3.length > 0 && box2.checkbox3.every(box3 => box3.isChecked);
          box2.isChecked = allBox3Checked;
          box2.isOpened = !allBox3Checked && isBox2Open;
        }
      });

      // box1の状態を更新（すべての子要素がチェックされていれば親もチェック）
      const allBox2Checked = box1.checkbox2.every(box2 => box2.isChecked);
      box1.isChecked = allBox2Checked;
      if (!box1.isOpened) {
        box1.isOpened = !allBox2Checked && isBox1Open;
      }
    }
  });

  // re-open checked sections
  const openedItems = document.querySelectorAll('#jobsearch-location-dialog-body .-is-opened');
  setTimeout(() => {
    openedItems.forEach(item => {
      if ((item as HTMLElement).style.display == 'none') {
        (item as HTMLElement).style.display = '';
      }
    });
  });
}

const store = useStore();
onMounted(async () => {
  dialogData.value = await store.dispatch(storeBase.DIALOG_PREF);

  // 初期選択値があれば設定
  if (props.selectedLocations && 
      (props.selectedLocations.jobsearchAreaid.length > 0 || 
       props.selectedLocations.jobsearchPrefid.length > 0 ||
       props.selectedLocations.jobsearchCityid.length > 0)) {
    updateCheckboxesFromIds(props.selectedLocations);
  }
});

// 既存のhandleCheckbox関数は変更なし
function handleCheckbox1(checkbox: Level1MstCityPref, isChecked: boolean) {
  // チェックボックス第1階層の状態を更新
  checkbox.isChecked = isChecked;

  // すべての第2階層チェックボックスを更新
  checkbox.checkbox2.forEach(box2 => {
    // チェックボックス第2階層の状態を更新
    box2.isChecked = isChecked;

    // すべての第3階層チェックボックスを更新
    box2.checkbox3.forEach(box3 => {
      box3.isChecked = isChecked;
    });
  });
}

function handleCheckbox2(checkbox: Level2MstCityPref, isChecked: boolean) {
  // チェックボックス第2階層の状態を更新
  checkbox.isChecked = isChecked;

  // すべての第3階層チェックボックスを更新
  checkbox.checkbox3.forEach(box3 => {
    box3.isChecked = isChecked;
  });

  // 親box1のIDを取得（box2.idの最初の1文字）
  const parentBox1Id = Number(checkbox.areaid);

  // 親box1を検索
  const box1Index = dialogData.value!.checkbox1.findIndex(box1 => Number(box1.id) === parentBox1Id);
  if (box1Index < 0) return;

  const box1 = dialogData.value!.checkbox1[box1Index];

  // 親box1の状態を更新
  // すべてのbox2がチェックされている場合 -> box1をチェック
  // 少なくとも1つのbox2がチェックされていない場合 -> box1のチェックを外す
  const allBox2Checked = box1.checkbox2.every(box2 => box2.isChecked);
  box1.isChecked = allBox2Checked;
}

function handleCheckbox3(checkbox: Level3MstCityPref, isChecked: boolean) {
  // チェックボックス第3階層の状態を更新
  checkbox.isChecked = isChecked;

  // 親box2のIDを取得（box3.idの最初の3文字）
  const parentBox2Id = checkbox.id.toString().split('_')[0];
  // 親box1のIDを取得（box3.idの最初の1文字）
  const parentBox1Id = Number(checkbox.areaid);

  // 親box1を検索
  const box1Index = dialogData.value!.checkbox1.findIndex(box1 => Number(box1.id) === parentBox1Id);
  if (box1Index < 0) return;

  // 親box2を検索
  const box2Index = dialogData.value!.checkbox1[box1Index].checkbox2.findIndex(box2 => box2.id === parentBox2Id);
  if (box2Index < 0) return;

  const box2 = dialogData.value!.checkbox1[box1Index].checkbox2[box2Index];

  // 親box2の状態を更新
  // すべてのbox3がチェックされている場合 -> box2をチェック
  // 少なくとも1つのbox3がチェックされていない場合 -> box2のチェックを外す
  const allBox3Checked = box2.checkbox3.every(box3 => box3.isChecked);
  box2.isChecked = allBox3Checked;

  // 親box1の状態を更新
  // すべてのbox2がチェックされている場合 -> box1をチェック
  // 少なくとも1つのbox2がチェックされていない場合 -> box1のチェックを外す
  const box1 = dialogData.value!.checkbox1[box1Index];
  const allBox2Checked = box1.checkbox2.every(box2 => box2.isChecked);
  box1.isChecked = allBox2Checked;
}

function toggleBox1(target: HTMLElement, box1: Level1MstCityPref) {
  const checkboxContainer = target.parentElement?.nextElementSibling as HTMLElement;
  if (checkboxContainer) {
    if (box1.isOpened) {
      domHelperUtils.toggle.initOpen(checkboxContainer);
      domHelperUtils.toggle.closeAccordion(checkboxContainer);
    } else {
      domHelperUtils.toggle.openAccordion(checkboxContainer);
    }
  }
  box1.isOpened = !box1.isOpened;
}

// This function is handled differently from the others because it needs to be optimized for performance on Safari.
async function toggleBox2(target: HTMLElement, box2: Level2MstCityPref) {
  if (box2.isOpened) {
    setTimeout(() => {
      box2.isOpened = false;
    }, 300);
  } else {
    box2.isOpened = true;
  }

  await nextTick();
  const checkboxContainer = target.parentElement?.nextElementSibling as HTMLElement;
  if (checkboxContainer) {
    if (checkboxContainer.classList.contains('-is-opened')) {
      domHelperUtils.toggle.initOpen(checkboxContainer);
      domHelperUtils.toggle.closeAccordion(checkboxContainer);
    } else {
      domHelperUtils.toggle.openAccordion(checkboxContainer);
      checkboxContainer.classList.add('-is-opened');
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialogData.value?.checkbox1, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: _normalizeClass(["p-jobsearch-search_tab_item js-tab-btn", { __current: !i}]),
                "data-tab": `place-tab${i + 1}`
              }, _toDisplayString(item.text), 11, _hoisted_6))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialogData.value?.checkbox1, (box1, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: box1.id,
                class: _normalizeClass(["p-jobsearch-search_tab-content js-tab-target", { __current: !i}]),
                id: `place-tab${i + 1}`
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: box1.isChecked,
                        onChange: ($event: any) => (handleCheckbox1(box1, ($event.target as HTMLInputElement).checked))
                      }, null, 40, _hoisted_14),
                      _createElementVNode("span", null, _toDisplayString(box1.text), 1)
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["p-jobsearch-search_accordion_btn js-jobsearch-acc-toggle", { '-is-opened': box1.isOpened, 'opacity-0': box1.id == _unref(MYPAGE_CONSTANTS).MSTAREA_FOREIGN_ID }]),
                      onClick: ($event: any) => (toggleBox1($event.target as HTMLElement, box1))
                    }, "開閉ボタン", 10, _hoisted_15)
                  ]),
                  (box1.id != _unref(MYPAGE_CONSTANTS).MSTAREA_FOREIGN_ID)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["p-jobsearch-search_accordion_content __second js-jobsearch-acc-target", { '-is-opened': box1.isOpened }])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(box1.checkbox2, (box2) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: box2.id,
                            class: "p-jobsearch-search_accordion __second"
                          }, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("label", _hoisted_17, [
                                _hoisted_18,
                                _createElementVNode("input", {
                                  checked: box2.isChecked,
                                  type: "checkbox",
                                  onChange: ($event: any) => (handleCheckbox2(box2, ($event.target as HTMLInputElement).checked))
                                }, null, 40, _hoisted_19),
                                _createElementVNode("span", null, _toDisplayString(box2.text), 1)
                              ]),
                              _createElementVNode("span", {
                                class: _normalizeClass(["p-jobsearch-search_accordion_btn", { '-is-opened': box2.isOpened }]),
                                onClick: ($event: any) => (toggleBox2($event.target as HTMLElement, box2))
                              }, "開閉ボタン", 10, _hoisted_20)
                            ]),
                            (box2.isOpened)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createElementVNode("div", _hoisted_22, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(box2.checkbox3, (box3) => {
                                      return (_openBlock(), _createElementBlock("label", {
                                        key: box3.id,
                                        class: "p-jobsearch-search_check"
                                      }, [
                                        _hoisted_23,
                                        _createElementVNode("input", {
                                          type: "checkbox",
                                          checked: box3.isChecked,
                                          onChange: ($event: any) => (handleCheckbox3(box3, ($event.target as HTMLInputElement).checked))
                                        }, null, 40, _hoisted_24),
                                        _createElementVNode("span", null, _toDisplayString(box3.text), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ], 2))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_9))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", { class: "p-jobsearch-search_card_footer" }, [
        _createElementVNode("button", {
          class: "p-jobsearch-search_clear",
          id: "clearModalSearch2",
          type: "button",
          onClick: clearAllSelections
        }, "条件をクリア"),
        _createElementVNode("button", {
          class: "p-jobsearch-search_set js-modal-close-trigger",
          type: "button",
          onClick: submitSelection
        }, "指定する")
      ])
    ]),
    _hoisted_25
  ], 64))
}
}

})